export const getiOSTransactionInfo = (url: URL): ITransactionInfo => {
  const data = decodeURI(url.searchParams.get("data") || JSON.stringify({}));

  const transactionInfo: {
    client_transaction_id: string;
    transaction_id: string;
    error_code?: string;
  } = JSON.parse(data);

  return {
    clientTransactionId: transactionInfo.client_transaction_id,
    transactionId: transactionInfo.transaction_id,
    errorCode: transactionInfo.error_code
  };
};

export const getAndroidTransactionInfo = (url: URL): ITransactionInfo => {
  const clientTransactionId = decodeURI(
    url.searchParams.get("com.squareup.pos.CLIENT_TRANSACTION_ID") || ""
  );

  const transactionId = decodeURI(
    url.searchParams.get("com.squareup.pos.SERVER_TRANSACTION_ID") || ""
  );

  const errorCode = decodeURI(
    url.searchParams.get("com.squareup.pos.ERROR_CODE") || ""
  );

  return {
    clientTransactionId,
    transactionId,
    ...(errorCode && { errorCode })
  };
};

interface ITransactionInfo {
  clientTransactionId: string | undefined;
  transactionId: string | undefined;
  errorCode?: string | undefined;
}



// WEBPACK FOOTER //
// ./src/services/square/index.ts